import { selector } from 'recoil';
import APIService from '../../APIService';
import { Apis } from '../../app.constants';
import { RecoilAtomKey } from '../../recoilConstantKey';
import { generateFilterKey } from '../../../utils/helper';
import { campaignDropdownStateAtom, campaignTableStateAtom } from './CampaignList.ts';

export const fetchCampaignListSelector = selector({
  key: RecoilAtomKey.fetchCampaignListSelectorKey,
  get: async ({ get }) => {
    const state = get(campaignTableStateAtom);
    const filterKey = generateFilterKey(state.filters);
    if (state.cache[filterKey]) {
      return {
        data: state.cache[filterKey],
        totalCount: state.totalCountCache[filterKey],
        fromCache: true,
      };
    }
    try {
      let params = `?to=${state?.filters?.to}&include_assigned_by=${state?.filters?.include_assigned_by}&fetch_all=${state?.filters?.fetch_all}&next_page=${state?.filters?.next_page + 1}&search=${state?.filters?.search || ''}&limit=${state?.filters?.limit || 10}`;
      const response = await APIService.get(`${Apis.Get_Campaign_Assignment}${params}`);
      if (response?.status === 200) {
        return {
          data: response?.data?.list || [],
          totalCount: response?.data?.count || 0,
          fromCache: false,
        };
      } else {
        return { data: [], totalCount: 0, fromCache: false };
      }
    } catch (error) {
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});

// import { selector } from 'recoil';
// import APIService from '../../APIService';
// import { Apis } from '../../app.constants';
// import { RecoilAtomKey } from '../../recoilConstantKey';
// import { generateFilterKey } from '../../../utils/helper';
// import { campaignTableStateAtom } from './CampaignListAtom.ts';
// // import { campaignTableStateAtom } from './CampaignList.ts';

export const fetchCampaignDropdownListSelector = selector({
  key: RecoilAtomKey.fetchCampaignDropdownListSelectorKey,
  get: async ({ get }) => {
    const state = get(campaignDropdownStateAtom);
    const filterKey = generateFilterKey(state.filters);
    if (state.cache[filterKey]) {
      return {
        data: state.cache[filterKey],
        totalCount: state.totalCountCache[filterKey],
        fromCache: true,
      };
    }
    try {
      // const page = state?.filters?.page || 0;
      const page = state?.filters?.next_page || 0;

      const limit = state?.filters?.limit || 10;
      let params = `?next_page=${page + 1}&limit=${limit}&search=${state?.filters?.search || ''}&organisation_id=${state?.filters?.organisation_id || ''}`;

      // let params = `?next_page=${state?.filters?.next_page + 1}&search=${state?.filters?.search || ''}&organisation_id=${state?.filters?.organisation_id || ''}`;
      const response = await APIService.get(`${Apis.getCampaingByOrganisation}${params}`);
      if (response?.status === 200) {
        return {
          data: response?.data?.list || [],
          totalCount: response?.data?.count || 0,
          fromCache: false,
        };
      } else {
        return { data: [], totalCount: 0, fromCache: false };
      }
    } catch (error) {
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});
